export interface ISelectInput {
  id: string;
  userUid?: string;
  contractUid?: string;
  merchantId?: string;
  text?: string;
  key?: string;
  alternateKey?: string;
  selector?: string;
  name?: string;
  direction?: string;
  shortname?: string;
  isChecked?: boolean;
  placeholder?: string;
  pattern?: RegExp;
  patternMessage?: string;
  filterSubMenu?: string;
  countSelectedItems?: number;
  currentSelectedIndex?: number;
  disabled?: boolean;
  argument?: string;
}

export interface ISelectCountFilterInput {
  filterSubMenu: string;
  countItems: number;
}
